<template lang="html">
  <b-container>
    <b-row>
      <b-col v-if="!$store.state.authorized" md="6">
        <h1>Login</h1>
        <Login />
      </b-col>
      <b-col v-if="$store.state.authorized" md="8">
        <AccountDetails />
      </b-col>
      <b-col v-if="$store.state.authorized" md="4">
        <p>
          <b-button variant="primary" @click="signOut()">Sign out</b-button>
        </p>
        <p>
          Logged in as <b>{{ $store.state.user.email }}</b>
        </p>
        <p v-if="$store.state.user.emailVerified">
          Your email address is verified.
        </p>
        <div v-else>
          <p>Your email address is not verified.</p>
          <b-btn size="sm" @click="$store.dispatch('sendEmailVerification')">
            Re-send verification email
          </b-btn>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Login from "@/components/Login.vue";
import AccountDetails from "@/components/AccountDetails.vue";

export default {
  name: "Account",
  components: {
    Login,
    AccountDetails
  },
  data() {
    return {};
  },
  methods: {
    signOut() {
      this.$store.dispatch("sign_out");
    }
  }
};
</script>

<style lang="css" scoped></style>
